/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import React from 'react';
import cn from 'classnames';
import { NavLink } from 'react-router-dom';

import styles from './MenuItem.module.scss';

export interface SidebarNavItem {
    icon: React.FunctionComponent<
        React.SVGProps<SVGSVGElement> & {
            title?: string | undefined;
        }
    >;
    props?: any;
    title: string;
    path?: string | { pathname: string };
    end?: boolean;
}

interface MenuItemProps extends SidebarNavItem {
    mt?: string;
    mb?: string;
    ml?: string;
    mr?: string;
    iconSize?: string;
    gap?: string;
    style?: React.CSSProperties;
    onClick?: () => void;
    styleText?: React.CSSProperties;
}

const MenuItem = ({
    icon,
    title,
    path,
    mt,
    mb,
    ml,
    mr,
    iconSize,
    gap = '4px',
    style = {},
    onClick,
    props,
    styleText = {},
    end = false,
}: MenuItemProps) => {
    const Icon = icon;

    const classStyle = ({ isActive }: { isActive: boolean; isPending: boolean }) => {
        return isActive ? cn(styles.root, styles.root_active) : styles.root;
    };

    return (
        <NavLink
            className={classStyle}
            style={{
                marginTop: mt ? mt : '',
                marginBottom: mb ? mb : '',
                marginLeft: ml ? ml : '',
                marginRight: mr ? mr : '',
                ...style,
            }}
            to={path ? path : ''}
            state={{ from: props }}
            end={end}
            onClick={onClick}
        >
            <div
                className={styles.iconWrapper}
                style={{
                    height: iconSize ? iconSize : '',
                    width: iconSize ? iconSize : '',
                    marginRight: gap,
                }}
            >
                <Icon className={styles.icon} />
            </div>
            <span className={styles.title} style={{ ...styleText }}>
                {title}
            </span>
        </NavLink>
    );
};

export default MenuItem;
